import(/* webpackMode: "eager" */ "/vercel/path0/components/error-block.tsx")